import { ReactElement, useState } from "react";
import { useForm } from "react-hook-form";
import { useToast } from "~/utils";
import { Content } from "~/components/aud/base/Content";
import { SectionTitle } from "~/components/aud/base/Section";
import { FormSubmitButton } from "~/components/FormSubmitButton";
import { signinPasswordRegex } from "~/validator/signin_password";
import { Me } from "~/generated/rtk-query/nowdo-live-api.generated";
import { useSignInMutation, useUpdateMeMutation } from "~/hooks/rtk-query-api";

export const ChangePasswordForm = ({ user }: { user: Me }): ReactElement => {
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [signIn] = useSignInMutation();
  const [updateMe] = useUpdateMeMutation();

  const onSubmit = async (data: { currentPassword: string; password: string }) => {
    try {
      setLoading(true);
      await signIn({
        signInInput: { email: user.email, password: data.currentPassword },
      }).unwrap();
      await updateMe({ updateMeInput: { password: data.password } }).unwrap();
      toast.success("パスワードを更新しました。");
    } catch (e) {
      toast.error("エラーが発生しました。お手数ですがもう一度時間を開けておためしください。");
    } finally {
      setLoading(false);
      reset();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} key={2}>
      <Content>
        <SectionTitle>パスワードの変更</SectionTitle>
        <div className="_form">
          <div className="field">
            <label>
              <span className="label">現在のパスワード</span>
              <input type="password" placeholder="●●●●●●●●" {...register("currentPassword", { required: true })} />
            </label>
            {errors.currentPassword && <span className="sub red">現在のパスワードを入力してください</span>}
          </div>
          <div className="field">
            <label>
              <span className="label">新しいパスワード</span>
              <input
                type="password"
                placeholder="●●●●●●●●"
                {...register("password", {
                  required: true,
                  minLength: 8,
                  pattern: signinPasswordRegex,
                })}
              />
            </label>
            {errors.password && (
              <span className="sub red">
                パスワードは8文字以上で、英字と数字が1文字以上含まれている必要があります。
                <br />
              </span>
            )}
            <span className="sub">8文字以上で、英語と数字を含む文字列</span>
          </div>
        </div>
        <p style={{ marginTop: "16px" }}>
          <FormSubmitButton size="medium" loading={loading}>
            パスワード変更
          </FormSubmitButton>
        </p>
      </Content>
    </form>
  );
};
